/**
 * Opt-in console tracing for the realtime layer, prefixed `[realtime]` so it
 * can be filtered in the console. Deliberately NOT tied to __DEV__ (which is
 * truthy in jest and would spam test output) — enable it explicitly:
 *
 *   localStorage.setItem('socrative:realtime-debug', '1')   // then refresh
 *   window.__REALTIME_DEBUG__ = true                        // immediate
 *
 * Disable with removeItem / `window.__REALTIME_DEBUG__ = false`.
 */

const STORAGE_KEY = 'socrative:realtime-debug';

let storageEnabled: boolean | null = null;

function readStorage(): boolean {
  if (storageEnabled === null) {
    try {
      storageEnabled = window.localStorage?.getItem(STORAGE_KEY) === '1';
    } catch {
      storageEnabled = false;
    }
  }
  return storageEnabled;
}

export function isRealtimeDebugEnabled(): boolean {
  return window.__REALTIME_DEBUG__ === true || readStorage();
}

/** Test hook: force re-read of the localStorage flag. */
export function resetRealtimeDebugCache() {
  storageEnabled = null;
}

export function realtimeLog(...args: unknown[]) {
  if (isRealtimeDebugEnabled()) {
    // Wall-clock ms timestamp — flap analysis needs to see how far apart
    // leave/join pairs land.
    // eslint-disable-next-line no-console
    console.log(
      `[realtime ${new Date().toISOString().slice(11, 23)}]`,
      ...args
    );
  }
}
